import React, { Component } from 'react'
import {Col, CardBody, Row} from 'reactstrap'

class ManualDescription extends Component {

  render() {
    return (
      <CardBody style={{backgroundColor: '#ffffff'}}>
        <Col md="12">
          <h1 className="manual-title" >Instrukcja obsługi weldinGo</h1>
          <p className="manual-title-description">Zapoznając się z tą instrukcją przeprowadzimy Cię przez wszystkie
            kroki działania aplikacji weldinGo, w tym miejscu dowiesz się jak wprowadzić
            informację o konstrukcji, przeprowadzić proces spawania, wydrukować raporty.
            Pokażemy Ci jak możesz szybko przechowywać informacje o technologiach
            wykorzystywanych w firmie - WPS. Pomożemy Ci również dodać spawaczy oraz
            inspektorów do systemu.
          </p>
          <div id="listContent">
            <h2 className="TableContentsSubtitle">Spis treści:</h2>
            <ol className="TableContents">
              <li><b><a href="#manual-project-link">Projekty</a></b>
                <ol>
                  <li><a href="#add-new-project">Dodawanie nowego projektu</a></li>
                  <li><a href="#edit-project">Edycja projektu</a></li>
                  <li><a href="#add-new-element">Dodawanie elementów i podelementów do projektu</a></li>
                  <li><a href="#remove-project-or-element">Usuwanie projektu lub elementu</a></li>
                  <li><a href="#add-inspection-category">Dodawanie kategorii badań do projektu</a>
                    <ol>
                      <li><a href="#edit-inspection-category">Edycja kategorii badań</a></li>
                      <li><a href="#remove-inspection-category">Usuwanie kategorii badań</a></li>
                    </ol>
                  </li>
                  <li><a href="#import-data">Import danych</a>
                    <ol>
                      <li><a href="#csv-file">Jak poprawnie przygotować plik CSV</a></li>
                      <li><a href="#correct-import">Prawidłowy import</a></li>
                      <li><a href="#incorrect-import">Nieprawidłowy import</a></li>
                    </ol>
                  </li>
                  <li><a href="#add-weld">Dodawanie spoiny</a></li>
                  <li><a href="#edit-and-remove-weld">Edycja i usuwanie spoiny</a></li>
                  <li><a href="#filter-welds">Filtrowanie spoin w projekcie i elementach</a></li>
                  <li><a href="#settings-in-welds-table">Ustawienia w tabeli spoin</a></li>
                  <li><a href="#percent-welding">Procent wyspawania spoiny</a>
                    <ol>
                      <li><a href="#edit-incorrect-data">Edycja błędnie wprowadzonych danych</a></li>
                      <li><a href="#progressbar">Postęp pracy na liście projektów</a></li>
                    </ol>
                  </li>
                  <li><a href="#inspectionp-type-on-weld">Typ badania spoiny</a>
                    <ol>
                      <li><a href="#correct-inspection">Poprawne badanie</a></li>
                      <li><a href="#incorrect-inspection">Niepoprawne badanie</a></li>
                    </ol>
                  </li>
                  <li><a href="#repairing-weld">Naprawianie spoiny</a></li>
                  <li><a href="#percent-welding-for-more-welds">Procent wyspawania i typ badania dla wielu spoin</a></li>
                  <li><a href="#weld-status">Status spoiny</a>
                    <ol>
                      <li><a href="#status-new">Status “new”</a></li>
                      <li><a href="#status-ready">Status “ready”</a></li>
                      <li><a href="#status-progress">Status “in progress”</a></li>
                      <li><a href="#status-ok">Status “ok”</a></li>
                      <li><a href="#status-failed">Status “failed”</a></li>
                      <li><a href="#status-inconsistent">Status “inconsistent”</a></li>
                    </ol>
                  </li>
                  <li><a href="#final-raport">Raport końcowy</a></li>
                  <li><a href="#logs">Logi</a>
                    <ol>
                      <li><a href="#welding-log">Logi spawania</a></li>
                      <li><a href="#inspection-log">Logi badania</a></li>
                      <li><a href="#edit-log">Edycja logów</a></li>
                      <li><a href="#remove-log">Usuwanie logów</a></li>
                      <li><a href="#weld-status-log">Status spoiny w logach</a></li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li><b><a href="#manual-wps-link">WPS</a></b>
                <ol>
                  <li><a href="#add-new-wps">Dodawanie nowego WPS</a>
                    <ol>
                      <li><a href="#add-own-params">Uzupełnianie pól wyboru własnymi danymi</a></li>
                      <li><a href="#add-more-params">Dodanie większej liczby parametrów/materiałów podstawowych</a></li>
                    </ol>
                  </li>
                  <li><a href="#edit-wps">Edycja i usuwanie WPS</a>
                    <ol>
                      <li><a href="#remove-own-params">Usuwanie wielu danych z pól wyboru</a></li>
                      <li><a href="#remove-more-params">Usuwanie parametrów/materiałów podstawowych</a></li>
                      <li><a href="#remove-wps">Usuwanie WPS</a></li>
                    </ol>
                  </li>
                  <li><a href="#assignment-to-weld">Przypisanie WPS do spoiny</a></li>
                </ol>
              </li>
              <li><b><a href="#manual-people-link">Osoby</a></b>
                <ol>
                  <li><a href="#add-new-person">Dodawanie nowej osoby i edycja</a></li>
                  <li><a href="#add-new-group">Dodawanie nowej grupy i edycja</a></li>
                  <li><a href="#add-group-to-person">Przypisanie grupy do osoby</a></li>
                  <li><a href="#remove-group-person">Zmiana lub usuwanie grupy przypisanej do osoby</a></li>
                  <li><a href="#add-user">Dodanie użytkownika</a></li>
                  <li><a href="#block-user">Blokowanie użytkownika</a></li>
                  <li><a href="#filter-people-and-users">Wyszukiwanie osób i użytkowników</a></li>
                </ol>
              </li>
              <li><b><a href="#manual-welders-link">Spawacze</a></b>
                <ol>
                  <li><a href="#add-new-welder">Dodawanie nowego spawacza</a></li>
                  <li><a href="#info-about-welder">Dodanie certyfikatu</a>
                    <ol>
                      <li><a href="#add-more-certificate">Dodanie kolejnego certyfikatu</a></li>
                    </ol>
                  </li>
                  <li><a href="#edit-certificate-welder">Edycja certyfikatu spawacza</a></li>
                  <li><a href="#remove-certificate-welder">Usunięcie certyfikatu spawacza</a></li>
                  <li><a href="#confirm-certificate-welder">Potwierdzenie certyfikatu spawacza</a></li>
                  <li><a href="#importance-certificate-welder">Ważność certyfikatu</a></li>
                  <li><a href="#filter-certificate-welder">Filtorwanie certyfikatów</a></li>
                </ol>
              </li>
              <li><b><a href="#manual-reports-link">Raporty</a></b>
                <ol>
                  <li><a href="#work-progress-raport">Raport postępu prac</a></li>
                  <li><a href="#project-defectiveness-raport">Raport wadliwości na projekcie</a></li>
                  <li><a href="#welder-defectiveness-raport">Raport wadliwości spawacza</a></li>
                </ol>
              </li>
            </ol>
          </div>
          <br/>
          <h1 className="title">
            <a id="manual-project-link" href="/projects" target='blank'
              style={{color: '#20a8d8', fontSize: '1.3rem', borderBottom: '1px solid #20a8d8'}}>
              Projekty
            </a>
          </h1>
          <h4 className="description" style={{fontSize: '.875rem'}}>
            Projekt - miejsce w którym budujemy konstrukcje z podziałem na elementy i podelementy.<br/>
            Dowiesz się jak utworzyć nowy projekt oraz podzielić go na mniejsze konstrukcje.
          </h4>
          <ol className="manual-list" style={{fontSize: '.875rem'}}>
            <li>
              <h2 id="add-new-project" className="subtitle" style={{fontSize: '.875rem'}}>Dodawanie nowego projektu</h2>
              <h5 style={{fontSize: '.875rem'}}>Kliknięcie w znajdujący się w bocznym menu link <b>Projects</b> wyświetla stronę z listą projektów.
                W celu dodania nowego projektu należy kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/add-project-btn.jpg')} alt="Add new project" height="30px"/>.<br/>
                Po kliknięciu przycisku pojawiają się pola formularza dodawania nowego projektu.<br/>
                Po wypełnieniu pól należy kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>
                , aby zapisać nowy projekt, lub&nbsp;
              <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>
                , by anulować.
              </h5>
              <h5>Po prawidłowym wypełnieniu pól formularza i zapisaniu, nowy projekt pojawi się na liście projektów.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/new_proj.jpg')}
                alt="New project on list" width="100%" />
            </li>

            <li>
              <h2 id="edit-project" className="subtitle">Edycja projektu</h2>
              <h5>Podstawowe zmiany w projekcie można wprowadzić przy pomocy przycisku szybkiej edycji&nbsp;
              <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/>
                , który wyświetli formularz projektu pozwalający na zmianę nazwy, numeru projektu,
                warunków, dat oraz dodanie lub usunięcie załączników. Po prawidłowo wprowadzonych zmianach
                wystarczy nacisnąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>
                , aby zapisać zmiany, lub&nbsp;
              <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>
                , by je anulować.
              </h5>
              <h5>Dalsza edycja projektu możliwa jest przez kliknięcie w link projektu.
                Tu również znajduje się przycisk edycji, pozwalający na wprowdzenie zmian.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/edit_proj.jpg')}
                alt="Edit more" width="100%" />
            </li>

            <li>
              <h2 id="add-new-element" className="subtitle">Dodawanie elementów i podelementów do projektu</h2>
              <h5>Po kliknięciu w link utworzonego projektu pojawia się możliwość dodania dowolnej liczby
                elementów projektu. Służy do tego przycisk&nbsp;
              <img className="" src={require('../../img/manual/add-small-btn.jpg')} alt="Add" height="30px"/>.<br/>
                Po kliknięciu tego przycisku pojawia się formularz <i>Add new element</i>. Po prawidłowym
                wypełnieniu pól formularza i kliknięciu przycisku&nbsp;
              <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>&nbsp;
                nowo utworzony element znajdzie się na liście elementów projektu.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/add_element.jpg')}
                alt="New element on list" width="100%" />
              <h5>Dodany element można edytować za pomocą przycisku szybkiej edycji  lub klikając w link z
                jego nazwą. <br/>Po kliknięciu w link z nazwą elementu można dodać kolejne podelementy.
              </h5>
            </li>

            <li>
              <h2 id="remove-project-or-element" className="subtitle">Usuwanie projektu lub elementu</h2>
              <h5>Do usuwania projektu lub elementu służy przycisk&nbsp;
              <img className="" src={require('../../img/manual/remove-btn.jpg')} alt="Remove" height="30px"/>
                , znajdujący się obok przycisku szybkiej edycji.<br/>
                Po kliknięciu przycisku usuwania, pojawia się okno, w którym należy potwierdzić lub anulować usuwanie.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/remove_proj.jpg')}
                alt="Remove element" width="100%" />
            </li>

            <li>
              <h2 id="add-inspection-category" className="subtitle">Dodawanie kategorii badań do projektu</h2>
              <h4 className="description">Kategoria badań określa które badania i w jakim zakresie należy wykonać na wyspawanych spoinach.</h4>
              <h5>Dodanie kategorii badań możliwe jest tylko na stronie projektu. W tym celu należy kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/insp-cat-btn.jpg')} alt="Inspection Category" height="30px"/>.<br/>
                Po kliknięciu tego przycisku pojawi się z strona kategorii badań z listą możliwych typów kategorii
                badań do wprowadzenia oraz przycisk pozwalający na dodanie nowej kategorii badań
              <img className="" src={require('../../img/manual/add-insp-cat-btn.jpg')} alt="Add Inspection Category" height="30px"/>.<br/>
                Po kliknięciu przycisku „+ New  category” pojawia się formularz z polami do wypełnienia.
                Możliwe jest dodanie kilku typów przy pomocy przycisku&nbsp;
              <img className="" src={require('../../img/manual/new-type-btn.jpg')} alt="Remove type" height="30px"/>&nbsp;
                lub usunięcie typu za pomocą przycisku&nbsp;
              <img className="" src={require('../../img/manual/minus-btn.jpg')} alt="Remove type" height="30px"/>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/insp_cat_1.jpg')}
                alt="Add new type" width="100%" />
              <h5>Po prawidłowym uzupełnieniu formularza i kliknięciu przycisku <i>Save</i> nowo utworzona kategoria znajdzie się
                na liście kategorii badań wraz z wprowadzonymi wartościami procentowymi dla wybranych typów.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/insp_cat_2.jpg')}
                alt="Inspection category on list" width="100%" />
              <ol className="manual-list-content">
                <li>
                  <h3 id="edit-inspection-category" className="sub-subtitle">Edycja kategorii badań</h3>
                  <h5>W celu edycji utworzonej kategorii badań należy kliknąć przycisk edycji&nbsp;
                  <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/>
                    , znajdujący się przy wybranej kategorii badań na liście kategorii.<br/>
                    Po kliknięciu przycisku pokaże się formularz kategorii badań uzupełniony wcześniej
                    wprowadzonymi danymi tej kategorii. W celu edycji należy zmienić dane i zapisać klikając przycisk&nbsp;
                  <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>, lub&nbsp;
                  <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>
                    , aby anulować zmiany.
                  </h5>
                </li>
                <li>
                  <h3 id="remove-inspection-category" className="sub-subtitle">Usuwanie kategorii badań</h3>
                  <h5>Do usuwania kategorii badań w listy kategorii służy przycisk usuwania&nbsp;
                  <img className="" src={require('../../img/manual/remove-btn.jpg')} alt="Remove" height="30px"/>.&nbsp;
                    Po jego kliknięciu wystarczy potwierdzić usuwanie kategorii wciskając przycisk <i>Remove</i>.
                  </h5>
                </li>
              </ol>
            </li>

            <li>
              <h2 id="import-data" className="subtitle">Import danych</h2>
              <h4 className="description">W aplikacji jest możliwość ręcznego lub automatycznego dodawania spoin (import z pliku csv).</h4>
              <h5>W celu importu danych z pliku .CSV należy najpierw przygotować poprawny plik.</h5>
              <br/>
              <h5>Następnie należy kliknąć przycisk importu.&nbsp;
              <img className="" src={require('../../img/manual/import-btn.jpg')} alt="Import" height="30px"/>.<br/>
                Po kliknięciu przycisku importu danych pojawia się formularz importu wraz z opcjami do wyboru.
                Po wyborze jednej z opcji, należy dodać plik w formacie .CSV oraz kliknąć przycisk <i>Import</i>,
                aby zaimportować plik lub <i>Close</i>, by anulować.<br/>
              <i className="fa fa-warning" />Import danych możliwy jest po wprowadzeniu Kategorii badań dla projektu.<br/>
              </h5>
              <img className="ManualImg" src={require('../../img/manual/import_1.jpg')}
                alt="Save import" width="100%" />
              <ol className="manual-list-content">
                <li>
                  <h3 id="csv-file" className="sub-subtitle">Jak poprawnie przygotować plik CSV</h3>
                  <a href={process.env.PUBLIC_URL + '/example_import_welds.csv'} download style={{color: '#20a8d8'}}>
                    <i className="fa fa-download" />Pobierz przykładowy plik CSV
                  </a>
                  <br/><br/>
                  <h5>Przykład poprawnie przygotowanego pliku .CSV.</h5>
                  <img className="" src={require('../../img/manual/import_csv.png')} alt="Import csv" width="100%" /><br/>
                </li>
                <br/>
                <li>
                  <h3 id="correct-import" className="sub-subtitle">Prawidłowy import</h3>
                  <h5>Gdy import danych jest prawidłowy dane z pliku .CSV pojawiają się w tabeli.</h5>
                  <img className="ManualImg" src={require('../../img/manual/import_2.jpg')}
                    alt="Correct import" width="100%" />
                </li>
                <li>
                  <h3 id="incorrect-import" className="sub-subtitle">Nieprawidłowy import</h3>
                  <h5>Gdy import jest nieprawidłowy użytkownik otrzymuje komunikat pojawiający się w prawym
                    górnym rogu ekranu oraz informację o błędach, które wystąpiły podczas importu danych z pliku CSV.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/import_3.jpg')}
                    alt="Incorrect import" width="100%" />
                  <h5>Po kliknięciu w przycisk <i>Info</i> możliwe jest sprawdzenie błędów importu danych.
                    Klikając przycisk <i>Close</i> ponownie ukrywa się informację o błędach.
                    Czerwony przycisk pozwala wyłączyć wyświetlaną tu informację.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/import_4.jpg')}
                    alt="Import errors" width="100%" />
                </li>
              </ol>
            </li>

            <li>
              <h2 id="add-weld" className="subtitle">Dodawanie spoiny</h2>
              <h5>Dodanie pojedynczej spoiny bez konieczności importowania z pliku .CSV możliwe jest przy użyciu  przycisku&nbsp;
              <img className="" src={require('../../img/manual/add-row-btn.jpg')} alt="Add row" height="30px"/>.<br/>
                Po kliknięciu tego przycisku pojawia się pusty wiersz z możliwością uzupełnienia
                kolejnych komórek tego wiersza.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/add_weld_1.jpg')}
                alt="Added weld" width="100%" />
              <h5>Po uzupełnieniu komórek wiersza konieczne jest zapisanie nowej spoiny za przycisku
                znajdującego się na końcu tabeli&nbsp;
              <img className="" src={require('../../img/manual/save-table.jpg')} alt="Save" height="15px"/>.<br/>
                W przypadku niepoprawnie wprowadzonych danych spoina nie zapisze się i pokaże się
                okno z komunikatem o błędach.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/add_weld_error.jpg')}
                alt="Errors weld" width="100%" />
            </li>

            <li>
              <h2 id="edit-and-remove-weld" className="subtitle">Edycja i usuwanie spoiny</h2>
              <h5>W celu edycji spoiny wystarczy dwukrotnie kliknąć na komórkę, do której mają być
                wprowadzone zmiany a następnie zapisać zmiany za pomocą znajdującego się na końcu tabeli przycisku&nbsp;
              <img className="" src={require('../../img/manual/save-table.jpg')} alt="Save" height="15px"/>.<br/>
                Aby usunąć spoinę wystarczy kliknąć w znajdujący się na końcu tabeli przycisk usuwania oraz potwierdzić
                w wyskakującym oknie przyciskiem&nbsp;
              <img className="" src={require('../../img/manual/remove-table.jpg')} alt="Remove" height="15px"/>.
              </h5>
            </li>

            <li>
              <h2 id="filter-welds" className="subtitle">Filtrowanie spoin w projekcie i elementach</h2>
              <h4 className="description">Umożliwia wyszukiwanie interesującej spoiny w projekcie lub elemencie w oparciu o wybrane kryteria.</h4>
              <h5>Do wyszukiwania spoiny bądź spoin służy przycisk&nbsp;
              <img className="" src={require('../../img/manual/filter-rows-btn.jpg')} alt="Filter rows" height="30px"/>.&nbsp;
                Po kliknięciu w ten przycisk pojawiają się filtry nad poszczególnymi kolumnami, umożliwiające wyszukiwanie
                spoiny po kilku parametrach jednocześnie.<br/>
                Po wprowadzeniu oczekiwanych parametrów filtrowania należy kliknąć przycisk filtrowania
                znajdujący się na końcu tabeli.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/filter_2.jpg')}
                alt="CLick button filter" width="100%" />
              <h5>Możliwe jest również filtrowanie ze wszystkich elementów i podelementów w projekcie jednocześnie.
                Aby to zrobić należy skorzystać w przycisku, który pokazuje wszystkie spoiny w jednej tabeli.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/filter_3.jpg')}
                alt="Show element welds" width="100%" />
              <br/>
              <img className="ManualImg" src={require('../../img/manual/filter_4.jpg')}
                alt="Show all welds" width="100%" />
            </li>

            <li>
              <h2 id="settings-in-welds-table" className="subtitle">Ustawienia w tabeli spoin</h2>
              <h5>Aplikacja umożliwia włączenie lub wyłączenie podglądu wybranych kolumn w tabeli spoin. Aby to
                zrobić należy zmienić jej ustawienia.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/settings.jpg')}
                alt="Show welds columns" width="100%" />
              <h5>Po kliknięciu przycisku pojawi się okno z automatycznie zaznaczonymi wszystkimi kolumnami, ktore
                znajdują się w tabeli spoin. Odznaczenie wybranej kolumny i kliknięcie przyciku <i>Save</i> spowoduje
                wyłączenie jej z podglądu tabeli</h5>
            </li>
            <img className="ManualImg" src={require('../../img/manual/settings_table.jpg')}
              alt="Show welds columns" width="100%" />

            <li>
              <h2 id="percent-welding" className="subtitle">Procent wyspawania spoiny</h2>
              <h4 className="description">Kiedy nowa, utworzona w tabeli lub zaimportowana z pliku .CSV spoina posiada
                podstawowe, wymagane parametry (typ, długość, grubość) aplikacja umożliwia wprowadzenie do tabeli
                wartości procentowej jej wyspawania.
              <br/>Procent spawanej spoiny pokazuje postęp w procesie spawania całej spoiny.
              </h4>
              <h5>Procent wyspawania danej spoiny wprowadza się w tabeli w kolumnie <i>Welding [%]</i>. W tym celu
                wystarczy dwukrotne kliknąć w komórkę.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/welding_1.jpg')}
                alt="Welding" width="100%" />
              <h5>Po kliknięciu pojawia się okno z formularzem do uzupełnienia.<br/>
                Procent wyspawania uzupełniany jest automatycznie jako 100. W celu wpisania w to pole innej
                liczby wystarczy w nie kliknąć.<br/>
                Aby zapisać wartości wprowadzone do formularza należy kliknąć przycisk&nbsp;
                <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>&nbsp;
                lub&nbsp;
                <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>
                , aby anulować.
              </h5>
              <h5>Po poprawnym uzupełnieniu i zapisaniu formularza, w komórce pojawi się pasek z procentową wartością
                spawania a w komórce obok nazwisko spawacza.<br/>
                W przypadku, gdy spawanie spoiny odbywa się w etapach, w tabeli wyświetla się nazwisko spawacza
                spawającego ostatni odcinek wprowadzonej do tabeli spoiny.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/welding_2.jpg')}
                alt="Added welding" width="100%" />
              <h5><i className="fa fa-warning" />Gdy procent wyspawania wynosi 100%, kliknięcie i wyedytowanie
                formularza nie jest możliwe.
              </h5>
              <ol className="manual-list-content">
                <li>
                  <h3 id="edit-incorrect-data" className="sub-subtitle">Edycja błędnie wprowadzonych danych</h3>
                  <h5>W przypadku błędnie wprowadzonych danych spawania dla spoiny, możliwa jest ich edycja przez
                    kliknięcie w przycisk&nbsp;
                  <img className="" src={require('../../img/manual/log-table.jpg')} alt="Logs" height="15px"/>&nbsp;
                    i przejście do zakładki <a href="#logs">„Logi”</a>.
                  </h5>
                </li>
                <li>
                  <h3 id="progressbar" className="sub-subtitle">Postęp pracy na liście projektów</h3>
                  <h5>Procentowy postęp prac spawania w danym projekcie lub elemencie przedstawiony jest również na liście
                    w postaci paska postępu.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/progesssbar.jpg')}
                    alt="Progress on project list" width="100%" />
                </li>
              </ol>
            </li>

            <li>
              <h2 id="inspectionp-type-on-weld" className="subtitle">Typ badania spoiny</h2>
              <h4 className="description">Po zakończeniu spawania spoina poddawana jest badaniom nieniszczącym,
                dyskwalifikującym powstawanie nieciągłości materiałowych. Aplikacja umożliwia przypisanie do danej spoiny
                kategorię badania oraz wprowadzenie danych do tabeli dla typów badań określonych w przypisanej do spoiny
                kategorii.
              </h4>
              <h5>Przed wprowadzeniem danych do typów badań konieczne jest przypisanie wcześniej utworzonej kategorii
                badań do spoiny. W tym celu wystarczy dwukrotnie kliknąć w komórkę kolumny <i>Inspection category</i> i wybrać
                kategorię z listy.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/weld_insp_1.jpg')}
                alt="Select inspection type" width="100%" />
              <h5>Po przypisaniu do spoiny kategorii badania i zapisie tabela powiększa się o kolumny z typami badań.<br/>
                Procent zbadania danej spoiny wprowadza się w tabeli w kolumnie odpowiadającej typowi badania poprzez
                dwukrotne kliknięcie w komórkę typu badania.<br/>
                Wartość w komórce podpowiada procent oraz długość przeprowadzenia badania w mm.</h5>
              <img className="ManualImg" src={require('../../img/manual/weld_inspect_2.jpg')}
                alt="Inspection type for weld" width="100%" />
              <h5>Po kliknięciu pojawia się okno z formularzem do uzupełnienia.<br/>
                Procent przebadania spoiny uzupełniany jest automatycznie w zależności od wartości wprowadzonej
                wcześniej w kategorii badań dla tego typu. W celu wpisania w to pole innej liczby wystarczy w nie kliknąć.
                <br/>Aby zapisać wartości wprowadzone do formularza należy nacisnąć przycisk <i>Save</i> lub <i>Cancel</i>, aby anulować.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/weld_inspect_3.jpg')}
                alt="Inspection type form" width="100%" />
              <h5>Po poprawnym wprowadzeniu badania do formularza i jego zapisie w komórce badanej spoiny dla tego
                typu badania w miejscu wartości pojawia się data przeprowadzonego badania.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/weld_inspect_4.jpg')}
                alt="Added inspection type" width="100%" />
              <ol className="manual-list-content">
                <li>
                  <h3 id="correct-inspection" className="sub-subtitle">Poprawne badanie</h3>
                  <h5>W przypadku, gdy badana spoina nie zawiera błędów i jej procent wyspawania jest poprawny,
                    data badania ma kolor zielony.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/weld_inspect_1.jpg')}
                    alt="Correct inspection type" width="100%" />
                </li>
                <li>
                  <h3 id="incorrect-inspection" className="sub-subtitle">Niepoprawne badanie</h3>
                  <h5>W przypadku, gdy badana spoina zawiera błędy, data badania ma kolor czerwony.</h5>
                  <img className="ManualImg" src={require('../../img/manual/weld_inspect_6.jpg')}
                    alt="Incorrect inspection type" width="100%" />
                  <h5>Gdy badanie spoiny jest błędne, zmienia się również komórka z wartością procentową
                    dla spawanej spoiny.
                  </h5>
                </li>
                <li>
                  <h3 className="sub-subtitle">Edycja błędnie wprowadzonych danych</h3>
                  <h5>W przypadku błędnie wprowadzonych danych badania dla spoiny, możliwa jest ich edycja przez
                    kliknięcie w przycisk&nbsp;
                  <img className="" src={require('../../img/manual/log-table.jpg')} alt="Logs" height="15px"/>&nbsp;
                    i przejście do zakładki <a href="#logs">„Logi”</a>.
                  </h5>
                </li>
              </ol>
            </li>

            <li>
              <h2 id="repairing-weld" className="subtitle">Naprawianie spoiny</h2>
              <h4 className="description">Aplikacja daje możliwość ponownego wprowadzania danych do tabeli w przypadku,
                gdy na wyspawanej spoinie konieczna jest naprawa.
              </h4>
              <h5>Jeżeli badanie przeprowadzone na spoinie po zakończeniu jej spawania zawiera błędy, data
                przeprowadzonego badania w tabeli ma kolor czerwony. Równocześnie wartość procentowa wyspawanej
                spoiny zmniejsza się o długość błędnie wyspawanego fragmentu spoiny.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/fix_weld_1.jpg')}
                alt="Fix weld" width="100%" />
              <h5>Konieczne jest spawanie błędnego fragmentu oraz wprowadzenie go ponownie do tabeli do
                komórki w kolumnie <i>Welding</i> (jako uzupełnienie do 100%). Następnie wprowadzenie do tabeli
                przeprowadzonego badania na naprawionym fragmencie spoiny.<br/>
                Jeżeli badanie spoiny nie zawiera błędów ma kolor zielony. Kolor czerwony oznacza, że wyspawana
                spoina nadal ma błędy i konieczne jest przeprowadzenie całej operacji ponownie.<br/>
                Jeżeli spoina naprawiana była dwukrotnie i nadal ma błędy, otrzymuje w tabeli status <i>failed</i>
                i nie można jej dalej edytować w tabeli.
              </h5>
            </li>

            <li>
              <h2 id="percent-welding-for-more-welds" className="subtitle">Procent wyspawania i typ badania dla wielu spoin</h2>
              <h4 className="description">Aplikacja daje możliwość wprowadzania danych dla procentu wyspawania oraz typu badania
                zarówno dla jednej, jak i dla wielu wybranych spoin. Operacja ta nie jest możliwa dla wszystkich
                elementów projektu jednocześnie.
              </h4>
              <h5>W celu dodania jednakowego procentu wyspawania lub badania dla wielu spoin należy
                zaznaczyć wybrane spoiny w pierwszej kolumnie tabeli.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/all_welds_1.jpg')}
                alt="Inspection type and welding" width="100%" />
              <h5>Po zaznaczeniu jednej lub więcej kolumn pojawiają się przyciski pozwalające na wprowadzenie danych do tabeli.</h5>
              <img className="ManualImg" src={require('../../img/manual/all_welds_2.jpg')}
                alt="Add nspection type and welding" width="100%" />
              <h5>Po kliknięciu w wybrany przycisk, otwiera się okno z odpowiednim formularzem do uzupełnienia danych.
                Po prawidłowym uzupełnieniu formularza i kliknięciu przycisku <i>Save</i> wprowadzone dane pojawiają się w tabeli.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/all_welds_3.jpg')}
                alt="Added inspection type and welding" width="100%" />
            </li>

            <li>
              <h2 id="weld-status" className="subtitle">Status spoiny</h2>
              <h4 className="description">Tabela spoin posiada kolumnę <i>Status</i>. Określa ona etap pracy nad spoiną.</h4>
              <ol className="manual-list-content">
                <li>
                  <h3 id="status-new" className="sub-subtitle">Status <i>new</i></h3>
                  <h5>Nowo utworzona spoina lub spoina, która ma przypisaną kategorię badań.</h5>
                  <img className="ManualImg" src={require('../../img/manual/status_new.jpg')}
                    alt="Status new" width="100%" />
                </li>
                <li>
                  <h3 id="status-ready" className="sub-subtitle">Status <i>ready</i></h3>
                  <h5>Spoina, która ma przypisaną kategorię badań oraz WPS.</h5>
                  <img className="ManualImg" src={require('../../img/manual/status_ready.jpg')}
                    alt="Status ready" width="100%" />
                </li>
                <li>
                  <h3 id="status-progress" className="sub-subtitle">Status <i>in progress</i></h3>
                  <h5>Spoina, która jest w trakcie spawania, badań lub naprawiania.</h5>
                  <img className="ManualImg" src={require('../../img/manual/statuss_in_progress.jpg')}
                    alt="Status in progress" width="100%" />
                </li>
                <li>
                  <h3 id="status-ok" className="sub-subtitle">Status <i>ok</i></h3>
                  <h5>Spoina, której spawanie zostało zakończone i wszystkie przeprowadzone badania są prawidłowe.</h5>
                  <img className="ManualImg" src={require('../../img/manual/status_ok.jpg')}
                    alt="Status ok" width="100%" />
                </li>
                <li>
                  <h3 id="status-failed" className="sub-subtitle">Status <i>failed</i></h3>
                  <h5>Spoina, która była dwukrotnie naprawiana i nie przeszła badań. Tym samym dyskwalifikuje
                    ją to z dalszej eksploatacji.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/status_failed.jpg')}
                    alt="Status failed" width="100%" />
                </li>
                <li>
                  <h3 id="status-inconsistent" className="sub-subtitle">Status <i>inconsistent</i></h3>
                  <h5>Spoina, której proces nie jest zachowany. Przyczyną tego może być np. niezgodność dat
                    spawania i badania, nieprawidłowy procent wykonania badania itp.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/status_inconsistent.jpg')}
                    alt="Status inconsistent" width="100%" />
                  <h5>
                    Nieprawidłowości, które wystąpiły przy wprowadzaniu spoiny do tabeli można sprawdzić w zakładce
                    <a href="#logs"><i>Logi</i></a>.
                  </h5>
                </li>
              </ol>
            </li>

            <li>
              <h2 id="final-raport" className="subtitle">Raport końcowy</h2>
              <h4 className="description">W aplikacji istnieje możliwość wygenerowania raportu końcowego dla projektu do pliku CSV. Utworzony
                raport odzwierciedla aktualny stan tabeli spoin w momencie jego utworzenia.
              </h4>
              <h5>Wygenerowanie raportu końcowego umożliwia przycisk&nbsp;
              <img className="" src={require('../../img/manual/final-report-btn.jpg')} alt="Final report" height="30px"/>&nbsp;.<br/>
                Raport końcowy tworzony jest dla całego projektu.<br/>
                Po kliknięciu przycisku można wybrać wersję raportu oraz dowolne kolumny, które raport będzie posiadał.
                Po zaznaczeniu kolumn oraz wersji raportu wystarczy kliknąć przycisk <i>Generate</i>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/raport_2.jpg')}
                alt="Add raport" width="100%" />
              <h5>Po kliknięciu przycisku <i>Generate</i> pojawia się widoczna informacja o statusie raportu.</h5>
              <img className="ManualImg" src={require('../../img/manual/raport_3.jpg')}
                alt="Info about raport" width="100%" />
              <h5>Klikając w ikonkę z informacją wyświetla się boczny panel. W panelu znajdują się informacje
                m.in. o statusie tworzenia raportu (pasek postępu wraz z %), ewentualnych błędach w tworzeniu
                raportu, przycisk pozwalający na pobranie poprawnie utworzonego raportu oraz przycisk wyłączający
                wyświetlaną tu informację. Aby pobrać raport końcowy należy kliknąć w zielony przycisk.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/raport_4.jpg')}
                alt="Download raport" width="100%" />
            </li>
            <li>
              <h2 id="logs" className="subtitle">Logi</h2>
              <h4 className="description">Aplikacja umożliwia użytkownikom korzystanie z dziennika zdarzeń dla każdej spoiny.
                Można sprawdzić tutaj historię spawania oraz badania, edytować ją lub całkowicie usunąć.
              </h4>
              <h5>Dziennik ten znajduje się w zakładce <b>Logs</b> i wyświetlany jest dla wybranej spoiny.
                Aby go wyświetlić należy kliknąć w przycisk znajdujący się na końcu wiersza w tabeli.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/log_1.jpg')}
                alt="Show logs" width="100%" />
              <h5>Po kliknięciu w przycisk wyświetli się strona, na której znajdują się informacje o spoinie
                oraz lista z historią spawania i badania spoiny. Jeżeli historia spoiny jeszcze nie istnieje, lista jest pusta.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/log_2.jpg')}
                alt="Logs" width="100%" />
              <h5>Jeżeli spoina ma przypisaną kategorię badań, wyświetli się dodatkowa lista z typami kategorii badań.</h5>
              <img className="ManualImg" src={require('../../img/manual/log_3.jpg')}
                alt="Inspection category on logs list" width="100%" />
              <h5>Jeżeli spoina posiada już historię - procent wyspawania i badania, wyświetli się lista <i>Logs</i>.</h5>
              <ol className="manual-list-content">
                <li>
                  <h3 id="welding-log" className="sub-subtitle">Logi spawania</h3>
                  <h5>Elementy na liście z zielonym tłem to historia spawania.</h5>
                  <img className="ManualImg" src={require('../../img/manual/log_4.jpg')}
                    alt="Welding logs" width="100%" />
                  <h5>Jeżeli spoina nie została jeszcze wyspawana w 100%, możliwe jest dalsze dodawania spawania
                    za pomocą przycisku&nbsp;
                  <img className="" src={require('../../img/manual/add-weldinglog-btn.jpg')} alt="Add weldinglog" height="30px"/>.
                  </h5>
                  <h5>Po kliknięciu tego przycisku pojawia się okno z formularzem. Pasek postępu pokazuje, jaki procent
                    spoiny został już wyspawany.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/log_6.jpg')}
                    alt="Welding logs form" width="100%" />
                  <h5>Dokładniejsze informacje można zobaczyć, klikając w element na liście logów.
                    Po kliknięciu rozwija się dodatkowe okno.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/log_7.jpg')}
                    alt="More about welding logs" width="100%" />
                  <h5>Jeżeli spoina została wyspawana w 100% przycisk <i>Add Welding Log</i> nie pojawia się.</h5>
                </li>
                <li>
                  <h3 id="inspection-log" className="sub-subtitle">Logi badania</h3>
                  <h5>Elementy na liście z niebieskim tłem to historia badań.</h5>
                  <img className="ManualImg" src={require('../../img/manual/log_8.jpg')}
                    alt="Inspection logs" width="100%"  />
                  <h5>Jeżeli badanie spoiny posiada błąd, oznaczone zostanie na liście <b>Logs</b> kolorem czerwonym.</h5>
                  <img className="ManualImg" src={require('../../img/manual/log_9.jpg')}
                    alt="Failed inspection logs" width="100%" />
                  <h5>Możliwe jest dodawanie badań dla spoiny za pomocą przycisku&nbsp;
                  <img className="" src={require('../../img/manual/add-inspection-log.jpg')} alt="Add inspectionlog" height="30px"/>.
                  </h5>
                  <h5>Po kliknięciu tego przycisku pojawia się okno z formularzem. Po prawidłowym wypełnieniu
                    formularza i kliknięciu przycisku <i>Save</i>, by go zapisać, kolejny log pojawi się na liście.<br/>
                    Dokładniejsze informacje można zobaczyć, klikając w element na liście logów. Po kliknięciu
                    rozwija się dodatkowe okno.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/log_11.jpg')}
                    alt="More about inspection logs" width="100%" />
                  <h5>Aby ponownie ukryć dodatkowe informacje wystarczy ponownie kliknąć na ten element na liście.</h5>
                </li>
                <li>
                  <h3 id="edit-log" className="sub-subtitle">Edycja logów</h3>
                  <h5>Przycisk edycji logów przydaje się, gdy dane zostaną niepoprawnie wprowadzone w tabeli lub w
                    zakładce <b>Logs</b> dla spoiny.<br/>Edycja możliwa jest poprzez kliknięcie przycisku edycji&nbsp;
                  <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/> na liście logów.<br/>
                    Po kliknięciu tego przycisku pojawi się formularz uzupełniony wcześniej wprowadzonymi danymi.
                    W celu edycji danych wystarczy je zmienić i zapisać za pomocą przycisku <i>Save</i>.
                  </h5>
                </li>
                <li>
                  <h3 id="remove-log" className="sub-subtitle">Usuwanie logów</h3>
                  <h5>W celu usunięcia wystarczy kliknąć przycisk usuwania, znajdujący się przy wybranym elemencie.
                    Następnie potwierdzić usuwanie przyciskiem&nbsp;
                  <img className="" src={require('../../img/manual/remove-btn.jpg')} alt="Remove" height="30px"/>.
                  </h5>
                </li>
                <li>
                  <h3 id="weld-status-log" className="sub-subtitle">Status spoiny w logach</h3>
                  <h5>Jeżeli proces spawania a następnie badania spoiny nie jest zachowany a spoina ma status <i>inconsistent</i>,
                    informacja o tym znajduje się w logach.<br/>Pojawia się dodatkowe okno w kolorze czerwonym z opisem
                    błędu, który wystąpił. Po znalezieniu błędu i jego edycji w odpowiednim logu możliwe jest jego
                    naprawienie i wyeliminowanie.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/log_14.jpg')}
                    alt="Status in logs" width="100%" />
                  <h5>Po edycji i naprawie odpowiedniego loga, czerwony komunikat znika a spoina przechodzi do
                    poprzedniego statusu np. <i>ok</i>.
                  </h5>
                </li>
              </ol>
            </li>
          </ol>

          <h1 className="title"><a id="manual-wps-link" href="/wps" target='blank'>WPS</a></h1>
          <h4 className="description">Lista WPS - miejsce, gdzie dodajemy instrukcję technologiczną spawania.<br/>Dowiesz
            się, jak dodać nową instrukcję, edytować już istniejącą lub jak ją przypisać do konkretnej spoiny.
          </h4>
          <ol className="manual-list">
            <li>
              <h2 id="add-new-wps" className="subtitle">Dodawanie nowego WPS</h2>
              <h5>Kliknięcie w bocznym menu w link <b>WPS</b> wyświetla stronę z listą WPS’ów.<br/>W celu dodania nowego WPS’a należy
                kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/add_wps_btn.jpg')} alt="Add new WPS" height="30px"/>.<br/>
                Po kliknięciu tego przycisku pokazuje się formularz dodawania nowego WPS’a.<br/>Pola formularza to
                podstawowe informacje z możliwością dodania załączników, parametry oraz materiały podstawowe.<br/>
                Po prawidłowym wypełnieniu pól formularza i kliknięciu przycisku&nbsp;
              <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>&nbsp;
                nowy WPS pojawi się na liście WPS’ów.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/new_wps_3.jpg')}
                alt="Added WPS" width="100%" />
              <ol className="manual-list-content">
                <li>
                  <h3 id="add-own-params" className="sub-subtitle">Uzupełnianie pól wyboru własnymi danymi</h3>
                  <h5>W formularzu znajdują się pola wyboru, które pozwalają na uzupełnienie wybranym parametrem z
                    rozwijanej listy lub na dodanie własnego.<br/> Aby dodać własny parametr wystarczy kliknąć w pole.
                    Gdy pojawi się kursor, wpisać własny parametr i zatwierdzić klawiszem enter.
                    W celu dodania kolejnego parametru należy powtórzyć czynność.
                  </h5>
                  <Row>
                    <Col md="6">
                      <img className="ManualImg" src={require('../../img/manual/new_wps_4.jpg')} alt="Add more" width="100%" />
                    </Col>
                  </Row>
                </li>
                <li>
                  <h3 id="add-more-params" className="sub-subtitle">Dodanie większej liczby parametrów/materiałów podstawowych</h3>
                  <h5>Formularz pozwala na dodanie większej liczby parametrów lub materiałów podstawowych do WPS’a.<br/>
                    W tym celu należy kliknąć w przycisk&nbsp;
                    <img className="" src={require('../../img/manual/add-btn.jpg')} alt="Add more" height="30px"/>&nbsp;
                    aktywujący dodatkowe pola formularza.
                  </h5>
                  <Row>
                    <Col md="6">
                      <img className="ManualImg" src={require('../../img/manual/new_wps_5.jpg')} alt="Add more" width="100%" />
                    </Col>
                  </Row>
                </li>
              </ol>
            </li>
            <li>
              <h2 id="edit-wps" className="subtitle">Edycja i usuwanie WPS</h2>
              <h5>W celu edycji utworzonego WPS’a należy przejść do listy WPS’ów, kliknąć przycisk edycji&nbsp;
              <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/>&nbsp;
                znajdujący się przy wybranym WPS’ie lub kliknąć w cały element na liście.
              </h5>
              <ol className="manual-list-content">
                <li>
                  <h3 id="remove-own-params" className="sub-subtitle">Usuwanie wielu danych z pól wyboru</h3>
                  <h5>Usunięcie pojedynczego parametru z pola jest możliwe przy użyciu przycisku <b>x</b>.</h5>
                  <Row>
                    <Col md="6">
                      <img className="ManualImg" src={require('../../img/manual/edit_wps_2.jpg')}
                        alt="Edit WPS" width="100%" />
                    </Col>
                  </Row>
                </li>
                <li>
                  <h3 id="remove-more-params" className="sub-subtitle">Usuwanie parametrów/materiałów podstawowych</h3>
                  <h5>Usunięcie parametrów lub materiałów podstawowych jest możliwe przy użyciu przycisku&nbsp;
                  <img className="" src={require('../../img/manual/minus-btn.jpg')} alt="Remove" height="30px"/>.
                  </h5>
                  <img className="ManualImg" src={require('../../img/manual/edit_wps_3.jpg')}
                    alt="Edit WPS" width="100%" />
                </li>
                <li>
                  <h3 id="remove-wps" className="subtitle">Usuwanie WPS</h3>
                  <h5>W celu usunięcia WPS’a należy przejść do listy WPS’ów, kliknąć przycisk usuwania&nbsp;
                  <img className="" src={require('../../img/manual/remove-btn.jpg')} alt="Remove" height="30px"/>&nbsp;
                    znajdujący się przy wybranym WPS’ie a następnie potwierdzić jego usuwanie.
                  </h5>
                </li>
              </ol>
            </li>
            <li>
              <h2 id="assignment-to-weld" className="subtitle">Przypisanie WPS do spoiny</h2>
              <h5>Przypisanie WPS’a do spoiny możliwe jest w tabeli spoin w wybranym projekcie lub jego elemencie
                w zakładce <b>Projects</b>.<br/>W celu przypisania WPS’a należy przejść więc do wybranej tabeli i
                kliknąć dwukrotnie w wybraną komórkę w kolumnie <i>WPS</i>.<br/>
                Gdy pojawi się pole z opcjami do wyboru, kliknąć w wybrany WPS oraz zapisać zmiany w spoinie za
                pomocą znajdującego się na końcu tabeli przycisku&nbsp;
              <img className="" src={require('../../img/manual/save-table.jpg')} alt="Save" height="15px"/>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/weld_wps_1.jpg')} alt="Weld WPS" width="100%" />
              <i className="fa fa-warning" />Do spoiny można przypisać tylko WPS’y oznaczone na liście WPS’ów jako aktualne.
              <img className="ManualImg" src={require('../../img/manual/weld_wps_3.jpg')} alt="Actual WPS" width="100%" />
            </li>
          </ol>

          <h1 className="title"><a id="manual-people-link" href="/people" target='blank'>Osoby</a></h1>
          <h4 className="description">Lista <b>People</b> to zbiór wszystkich ludzi znajdujących się w systemie, również tych,
            którzy nie mają uprawnień do logowania się do aplikacji.<br/>Dowiesz się, jak dodać nowe osoby oraz jak
            przypisać im odpowiednie grupy i nadać uprawnienia.
          </h4>
          <ol className="manual-list">
            <li>
              <h2 id="add-new-person" className="subtitle">Dodawanie nowej osoby i edycja</h2>
              <h5>Kliknięcie w znajdujący się w bocznym menu link <b>People</b> wyświetla stronę z listą osób.<br/>
                W celu dodania nowej osoby należy kliknąć przycisk&nbsp;
                <img className="" src={require('../../img/manual/add-person-btn.jpg')} alt="Add new person" height="30px"/>.
              </h5>
              <h5>
                Po kliknięciu przycisku pojawiają się pola formularza dodawania nowej osoby.<br/>
                Po poprawnym wypełnieniu pól należy kliknąć przycisk&nbsp;
                <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>
                , aby dodać nową osobę, lub&nbsp;
                <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>
                , by anulować.<br/>Zapisana nowa osoba pojawi się na liście w zakładce <b>People</b>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/new_person_3.jpg')}
                alt="New person on list" width="100%" />
              <h5>Edycja osoby za pomocą przycisku edycji&nbsp;
              <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/>.
              </h5>
              <h5><i className="fa fa-warning" />Usuwanie osoby nie jest możliwe. Osobę można oznaczyć na liście jako nieaktywną.</h5>
            </li>
            <li>
              <h2 id="add-new-group" className="subtitle">Dodawanie nowej grupy i edycja</h2>
              <h5>Kliknięcie w przycisk&nbsp;
              <img className="" src={require('../../img/manual/manage-groups-btn.jpg')} alt="Manage group" height="30px"/>&nbsp;
                otwiera zakładkę <b>Groups</b>.
              </h5>
              <h5>Tutaj wyświetla się lista wszystkich utworzonych wcześniej grup oraz przycisk pozwalający na utworzenie nowej grupy&nbsp;
              <img className="" src={require('../../img/manual/new-group-btn.jpg')} alt="Add new group" height="30px"/>.<br/>
                Po kliknięciu tego przycisku pokazuje się formularz, który określa uprawnienia grupy.<br/>
                Po poprawnym wypełnienu formularza należy kliknąć&nbsp;
              <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>, aby dodać nową grupę, lub&nbsp;
              <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>, by anulować.
              </h5>
              <h5>Zapisana nowa grupa pojawi się na liście w zakładce <b>Groups</b>.</h5>
              <img className="ManualImg" src={require('../../img/manual/menage-groups.jpg')}
                alt="New group on list" width="100%" />
              <h5>Edycja grupy za pomocą przycisku edycji&nbsp;
              <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/>.<br/>
              <i className="fa fa-warning" />Usuwanie grupy nie jest możliwe.
              </h5>
            </li>
            <li>
              <h2 id="add-group-to-person" className="subtitle">Przypisanie grupy do osoby</h2>
              <h5>Przypisanie grupy do osoby możliwe jest podczas tworzenia nowej lub edycji istniejącej już osoby.<br/>
                Aby to zrobić należy kliknąć w znajdujące się w formularzu pole wyboru <i>Groups</i> i wybrać określoną grupę.<br/>
                Możliwe jest przypisanie więcej niż jedna grupa do danej osoby.<br/>
                Przypisana grupa wyświetli się również na liście osób.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/group-to-person.jpg')}
                alt="Add group to person" width="100%" />
              <h5>Przypisanie osoby do grupy określa uprawnienia oraz elementy aplikacji, do których dana grupa ma dostęp.</h5>
            </li>
            <li>
              <h2 id="remove-group-person" className="subtitle">Zmiana lub usuwanie grupy przypisanej do osoby</h2>
              <h5>Zmiana lub usunięcie grupy przypisanej do osoby możliwe jest po kliknięciu przyciku edycji.<br/>
                Wystarczy kliknąć przycisk usuwania znajdujący się przy wybranej grupie w polu <i>Groups</i> i zapisać zmiany.</h5>
              <Row>
                <Col md="6">
                  <img className="ManualImg" src={require('../../img/manual/remove-group-to-person.jpg')}
                    alt="Remove group person" width="100%" />
                </Col>
              </Row>
            </li>
            <li>
              <h2 id="add-user" className="subtitle">Dodanie użytkownika</h2>
              <h5>Dodanie nowego użytkownika aplikacji możliwe jest dla stworzonej już osoby.
                W tym celu należy kliknąć w przycisk&nbsp;
              <img className="" src={require('../../img/manual/new-user-btn.jpg')} alt="New user" height="30px" />&nbsp;
                znajdujący się przy tej osobie na liście.<br/>
                Następnie należy uzupełnić formularz podając adres e-mail użytkownika oraz hasło wraz z jego potwierdzeniem.<br/>
                Kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/save-btn.jpg')} alt="Save" height="30px"/>, aby dodać nowego użytkownika, lub&nbsp;
              <img className="" src={require('../../img/manual/close-btn.jpg')} alt="Close" height="30px"/>, by anulować.<br/>
                Podane tu dane są danymi uzytkownika do zalogowania się do aplikacji.<br/>
                Po utworzeniu użytkownika dla wybranej osoby jego adres e-mail pojawi się na liście.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/add-user-to-person.jpg')}
                alt="New user" width="100%" />
              <h5>Edycja użytkownika za pomocą przycisku edycji&nbsp;
              <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit" height="30px"/>.
              </h5>
            </li>
            <li>
              <h2 id="block-user" className="subtitle">Blokowanie użytkownika</h2>
              <h5>Aplikacja nie pozwala na usuwanie użytkownia. Umożliwia jednak zablokowanie użytkownika przy pomocy przycisku&nbsp;
              <img className="" src={require('../../img/manual/lock-btn.jpg')} alt="Close" height="30px"/>.<br/>
                Po kliknięciu przycisku na liście pojawi się informacja o zablokowaniu dostępu do aplikacji dla wybranego użytkownika.<br/>
                W celu odblokowania dostępu należy ponownie kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/lock-btn.jpg')} alt="Close" height="30px"/>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/user-block.jpg')}
                alt="Users blocked" width="100%" />
            </li>
            <li>
              <h2 id="filter-people-and-users" className="subtitle">Wyszukiwanie osób i użytkowników</h2>
              <h5>Kilkając przycisk&nbsp;
              <img className="" src={require('../../img/manual/filter-btn.jpg')} alt="Filter" height="30px"/>&nbsp;
                pojawia się formularz wyszukiwania pozwalający na filtorwanie po dowolnych parametrach.<br/>
                Po uzupełnieniu wybranych pól, aby przefiltrować listę należy kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/apply-btn.jpg')} alt="Apply" height="30px"/>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/filter-people.jpg')}
                alt="Filter people and users" width="100%" />
            </li>
          </ol>

          <h1 className="title">
            <a id="manual-welders-link" href="/welders" target='blank'>Spawacze</a>
          </h1>
          <h4 className="description">Lista Welders zawiera zbiór wszystkich spawaczy.
            Możesz tutaj dodać certyfikaty i zakres kwalifikacji, jakie posiada spawacz.
          </h4>
          <ol className="manual-list">
            <li>
              <h2 id="add-new-welder" className="subtitle">Dodawanie nowego spawacza</h2>
              <h5>W celu dodania nowego spawacza konieczne jest dodanie nowej osoby w zakładce <b>People</b>
                wraz z przypisaniem mu grupy <i>Welder</i>.<br/>
                <a href="#add-new-person">Sprawdź, jakak dodać nową osobę?</a><br/>
                <a href="#add-group-to-person">Sprawdź, jak przypisać grupe?</a><br/>
                Spawacz pojawi się na liście w zakładce <b>Welders</b> dopiero, kiedy przypiszemy mu certyfikat.
              </h5>
            </li>
            <li>
              <h2 id="info-about-welder" className="subtitle">Dodanie certyfikatu</h2>
              <h5>Aby przypisać certyfikat należy kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/add-certificate.jpg')} alt="Add certificate" height="30px"/>.&nbsp;
                Następnie uzupełnić odpowiednie pola w formularzu i zapisać. Niektóre pola w formularzu umożliwiają dodanie kilku wartości.<br/>
                Spawacz wraz z uzupełnionymi danymi pojawi się w tabeli na liście spawaczy.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/add-welder.jpg')} alt="Add info about welder" width="100%" />
              <h5>Tabela umożliwia ukrycie informacji o certyfikatach lub kwalifikachach przy pomocy przełącznika dostępnego w jej nagłówku.<br/>
                <i className="fa fa-warning" />Wyłączenie certyfikatów ukrywa również przyciski akcji.
              </h5>
              <ol className="manual-list-content">
                <li>
                  <h3 id="add-more-certificate" className="sub-subtitle">Dodanie kolejnego certyfikatu</h3>
                  <h5>Dodanie kolejnego certyfikatu dla spawacza umożliwia przycisk dodawania&nbsp;
                  <img className="" src={require('../../img/manual/add-small-btn.jpg')} alt="Add" height="30px"/>,&nbsp;
                    znajdujący się przy konkretnym spawaczu. Po jego kliknięciu pojawia się formularz danych do uzupełnienia.
                  </h5>
                </li>
              </ol>
            </li>
            <li>
              <h2 id="edit-certificate-welder" className="subtitle">Edycja certyfikatu spawacza</h2>
              <h5>Zmiany w ceftyfikacie spawacza umożliwia przycisk edycji&nbsp;
              <img className="" src={require('../../img/manual/edit-btn.jpg')} alt="Edit certificate" height="30px"/>,&nbsp;
                znajdujący się przy każdym certyfikacie na liście. Po jego kliknięciu pokazuje się wcześniej
                wypełniony formularz z danymi, które można zmienić.
              </h5>
            </li>
            <li>
              <h2 id="remove-certificate-welder" className="subtitle">Usunięcie certyfikatu spawacza</h2>
              <h5>W celu usunięcia certyfikatu spawacza należy kliknąc przycisk&nbsp;
              <img className="" src={require('../../img/manual/remove-btn.jpg')} alt="Edit certificate" height="30px"/>,&nbsp;
                następnie potwierdzić.
              </h5>
            </li>

            <li>
              <h2 id="confirm-certificate-welder" className="subtitle">Potwierdzenie ważności certyfikatu</h2>
              <h5>Kliknięcie w przycisk&nbsp;
              <img className="" src={require('../../img/manual/confirm-btn.jpg')} alt="Edit certificate" height="30px"/>&nbsp;
                pozwala dodać potwierdzenie ważności cerfyfikatu spawacza - załącznik wraz z datą.<br/>
                Uzupałnione tu dane wyświetlą się w tabeli <i>Welders</i> w kolumnie <i>Expiration/Confirmation</i> jako <i>Confirmation</i>.
              </h5>
            </li>
            <li>
              <h2 id="importance-certificate-welder" className="subtitle">Data wygaśnięcia i ważność certyfikatu</h2>
              <h5>Na liście w kolumnie <i>Expiration/Confirmation</i> wyświetlane są daty ważności certyfikatów oznaczone kolorami:
              <ul className="manual-list-content">
                <li><b style={{color: 'red'}}>czerwony</b> - minęła data ważności,</li>
                <li><b style={{color: 'orange'}}>pomarańczowy</b> - pozostał miesiąc,</li>
                <li><b>czarny </b> - pozostałe.</li>
              </ul>
                Dodatkowo oprócz daty wygaśnięcia/ważności certyfikatu w nawiasie podana jest liczba dni ważności.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/certificate-color.jpg')}
                alt="Remove certificate" width="100%" />
            </li>
            <li>
              <h2 id="filter-certificate-welder" className="subtitle">Filtorwanie certyfikatów</h2>
              <h5>W nagłówku tabeli znajduje się przycisk &nbsp;
              <img className="" src={require('../../img/manual/filter-btn.jpg')} alt="Filter" height="30px"/>,&nbsp;
                Po jego kliknięciu, pojawia się formularz wyszukiwania pozwalający na filtorwanie po dowolnych parametrach.<br/>
                Po uzupełnieniu wybranych pól, aby przefiltrować listę należy kliknąć przycisk&nbsp;
              <img className="" src={require('../../img/manual/apply-btn.jpg')} alt="Apply" height="30px"/>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/filter-cert.jpg')}
                alt="Filter" width="100%" />
            </li>
          </ol>

          <h1 className="title">
            <a id="manual-reports-link" href="/reports" target='blank'>Raporty</a>
          </h1>
          <h4 className="description">Zakładka <b>Reports</b> zawiera zbiór raportów dla projektów.<br/>
            Możesz tutaj sprawdzić m.in. postęp pracy i wadliwość w wybranym projekcie lub jego elemencie oraz wadliwość spawaczy.<br/>
            Po kliknięciu w link wyświetla się lista raportów do wybrania.
          </h4>
          <Row>
            <Col md="6">
              <img className="ManualImg" src={require('../../img/manual/reports-list.jpg')}
                alt="Reports list" width="100%" />
            </Col>
          </Row>
          <ol className="manual-list">
            <li>
              <h2 id="work-progress-raport" className="sub-subtitle">Raport postępu prac (<i>Work progress</i>)</h2>
              <h4 className="description">Raport ten pozwala porównać pracę planowaną oraz wykonaną przedstawioną
                według wybranego zakresu dat.
              </h4>
              <h5>
                Kliknięcie w link <b>Work progress</b> kieruje do strony, gdzie pojawia się formularz z polami do wyboru
                oraz wykres postępu prac.<br/>Formularz znajdujący się na stronie pozwala łatwo filtrować dane. Wystarczy
                w polu wyboru wybrać projekt lub projekt wraz z elementem w polu poniżej a następnie wybrać oczekiwany
                zakres dat. Aktualna data uzupełnia się automatycznie, więc nie trzeba jaj uzupełniać lub należy ją zmienić,
                kiedy użytkownika interesuje inny zakres czasowy.<br/>Następnie należy kliknąć przycisk&nbsp;
                <img className="" src={require('../../img/manual/filter-reports-btn.jpg')} alt="Filter date" height="30px"/>
                , by wyszukać dane i zobaczyć ich wynik na poniższym wykresie.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/work-progress-raport.jpg')}
                alt="Work progress report" width="100%" />
            </li>
            <li>
              <h2 id="project-defectiveness-raport" className="sub-subtitle">Raport wadliwości na projekcie (<i>Project defectiveness</i>)</h2>
              <h4 className="description">
                Raport przedstawia wadliwość spoin na wybranym projekcie lub jego elemencie według badań nieniszczących.
              </h4>
              <h5>
                Po kliknięciu w link <b>Project defectiveness</b> pojawia się formularz z polami do wyboru oraz tabela wadliwości dla projektów.<br/>
                Formularz znajdujący się na stronie pozwala łatwo wybrać dane. Wystarczy kliknać w pole wyboru i wybrać
                projekt lub projekt wraz z elementem w polu poniżej.<br/>
                Dane dla wybranego projektu lub elementu pojawią się w tabeli pod formularzem.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/raport-defectivesess-list.jpg')}
                alt="Defectiveness report list" width="100%" />
            </li>
            <li>
              <h2 id="welder-defectiveness-raport" className="sub-subtitle">Raport wadliwości spawacza (<i>Welder defectiveness</i>)</h2>
              <h4 className="description">Raport przedstawia nieprawidłowości w pracy spawaczy według badań nieniszczących.</h4>
              <h5>Kliknięcie w link <b>Welder defectiveness</b> kieruje do strony, gdzie pojawia się formularz i tabela wadliwości.<br/>
                Tabela przedstawia sumę wyników pracy spawaczy na wszystkich projektach, wybranym projekcie i jego
                elemencie lub konkretnym spawaczu.<br/>
                Aby wyszukać określone dane należy skorzystać z formularza wyszukiwania, wypełnić wybrane pola a następnie kliknąc przycisk&nbsp;
                <img className="" src={require('../../img/manual/filter-reports-btn.jpg')} alt="Filter" height="30px"/>.
              </h5>
              <img className="ManualImg" src={require('../../img/manual/welder-defectivesess-list.jpg')}
                alt="Welder defectiveness report list" width="100%" />
            </li>
          </ol>
        </Col>
      </CardBody>
    )
  }
}
export default ManualDescription



// WEBPACK FOOTER //
// ./src/components/Manual/ManualDescription.js